import { GridItem } from '@chakra-ui/react';

const CloneCM = ({ name, img64, miniatureStyle }) => {
	return (
		<GridItem {...miniatureStyle}>
			<figure style={{ margin: 0, height: '100px', display: 'flex', flexDirection: 'column' }}>
				<img alt={name} src={img64} style={{ maxHeight: '68px', margin: 'auto' }} />
				<figcaption>{name}</figcaption>
			</figure>
		</GridItem>
	);
};

export default CloneCM;
